import { useLocale } from "../hooks/useLocale";
import { msg } from "../locales/translate";
import { Box, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import { Table } from "@ui/table/Table";
import { Typo } from "@ui/text/Typo";
import { usePresenter } from "badmfck-presenter";
import { GD } from "../GD";
import { IProject } from "../services/Projects";

export const ProjectsView = ({ tiny }: { tiny?: boolean }) => {
	useLocale();
	const [profile] = GD.REQ_PROFILE.useRequest();
	const presenter = usePresenter();

	if (!profile) return <div>{msg("noProfile")}</div>;

	const openProject = (p: IProject) => {
		presenter.navChange("project", { id: p.name });
	};

	const callProjectEditor = () => {
		GD.S_PROJECT_EDITOR.invoke({ projectID: -1 });
	};

	if (tiny) {
		return (
			<Box>
				<VBox>
					{profile.projects?.map((p, i) => (
						<Box
							key={i}
							sx={{
								padding: "12px",
								borderBottom:
									"1px dashed rgba(169, 189, 214, 0.3)",
								cursor: "pointer",
								transition: "background-color .3s",
								borderRadius: "6px",
								display: "grid",
								gap: "10px",
								gridTemplateColumns: "1fr  max-content",
								alignItems: "center",
								"&:hover": {
									backgroundColor: "rgba(169, 189, 214, 0.3)",
								},
								"&:last-child": {
									borderBottom: "none",
								},
							}}
							onClick={() => GD.S_PROJECT_SELECTED.invoke(p)}>
							<VBox>
								<Typo>{p.name}</Typo>
								{/* <TypoCaption>{p.type}</TypoCaption> */}
							</VBox>
							{/* <TypoCaption
								bold
								color={
									p.status === "active"
										? "#009688"
										: undefined
								}>
								{p.status}
							</TypoCaption> */}
						</Box>
					))}
				</VBox>
			</Box>
		);
	}

	return (
		<Box>
			<Table<IProject>
				appendCells={[{ header: msg("actions"), value: "actions" }]}
				data={profile.projects ?? []}
				onRowClick={(row, _cell) => {
					if (_cell === "actions") {
						GD.S_PROJECT_EDITOR.invoke({ projectID: row.id });
						return;
					}
					openProject(row);
				}}
			/>
			<Button onClick={() => callProjectEditor()}>{msg("addProject")}</Button>
		</Box>
	);
};
